export const SERVICES_TITLE="SERVICES_TITLE";
export const SERVICES_SUBTITLE="SERVICES_SUBTITLE";

export const SERVICES_PANEL_LABEL = "SERVICES_PANEL_LABEL";
export const SERVICES_PANEL_HEADING = "SERVICES_PANEL_HEADING";
export const SERVICES_INTRO_PARAGRAPH = "SERVICES_INTRO_PARAGRAPH";
export const SERVICES_CARD_BTN = "SERVICES_CARD_BTN";
export const INPUT_BADGE = "INPUT_BADGE";
export const INPUT_CARD_DESC = "INPUT_CARD_DESC";
export const OUTPUT_BADGE = "OUTPUT_BADGE";
export const OUTPUT_CARD_DESC = "OUTPUT_CARD_DESC";
export const ADVISORY_CARD_DESC = "ADVISORY_CARD_DESC";
export const FINANCIAL_CARD_DESC = "FINANCIAL_CARD_DESC";